import { PlusOutlined } from '@ant-design/icons'
import TextArea from 'antd/es/input/TextArea'
import { requestUpdateRewardActivity } from 'app/api/reward'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { InputNumber } from 'app/components/common/inputs/InputNumber'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import {
  IRewardActivity,
  RewardTypeEnum,
} from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { notificationController } from 'app/controllers/notification-controller'
import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

export const ModalUpdateReward = ({ reward }: { reward: IRewardActivity }) => {
  const [form] = BaseForm.useForm<IRewardActivity>()
  const modalRef = useRef<IRefModal>({})
  const [loading, setLoading] = useState(false)

  const openModal = () => {
    modalRef?.current?.open?.()
  }

  const handleSubmit = async (values: IRewardActivity) => {
    if (!reward?.id) return
    try {
      setLoading(true)
      const res = await requestUpdateRewardActivity({
        countPerReward: values?.countPerReward,
        description: values?.description,
        gift: values?.gift,
        name: values?.name,
        type: values?.type,
        id: reward?.id,
      })

      if (res) {
        modalRef?.current?.hide?.()
        notificationController.success({ message: 'Thành công!' })
        window.location.reload()
        form?.resetFields?.()
      }
    } catch (error) {
      console.log({ error })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    form.setFieldsValue({
      countPerReward: reward?.countPerReward,
      description: reward?.description,
      gift: reward?.gift,
      name: reward?.name,
      type: reward?.type,
    })
  }, [reward])

  return (
    <BaseModalComponent
      titleModal={'Cập nhật giải thưởng'}
      handleSubmit={form?.submit}
      ref={modalRef}
      isLoadingConfirm={loading}
      buttonOpenModal={
        <BaseButton type='text' icon={<PlusOutlined rev={undefined} />} onClick={openModal}>
          {'Cập nhật'}
        </BaseButton>
      }
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <BaseForm.Item
            label={'Tên giải thưởng'}
            name={'name'}
            required
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập tên giải thưởng',
              },
            ]}
          >
            <BaseInput placeholder="Nhập tên giải thưởng" />
          </BaseForm.Item>

          <BaseForm.Item
            label={'Mô tả giải thưởng'}
            name={'description'}
            required
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập mô tả giải thưởng',
              },
            ]}
          >
            <TextArea placeholder="Nhập mô tả giải thưởng" />
          </BaseForm.Item>

          <BaseForm.Item
            label={'Số giải thưởng'}
            name={'countPerReward'}
            required
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập số giải thưởng',
              },
            ]}
            initialValue={1}
          >
            <InputNumberWrapper min={1} placeholder="Nhập số giải thưởng" />
          </BaseForm.Item>

          <BaseForm.Item
            label={'Phần quà'}
            name={'gift'}
            required
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập phần quà',
              },
            ]}
          >
            <BaseInput placeholder="Nhập phần quà" />
          </BaseForm.Item>

          <BaseForm.Item
            label={'Đối tượng nhận giải'}
            name={'type'}
            required
            rules={[
              {
                required: true,
                message: 'Vui lòng chọn đối tượng nhận giải',
              },
            ]}
          >
            <BaseSelect
              placeholder={'Chọn đối tượng nhận giải'}
              options={[
                {
                  label: 'Cá nhân',
                  value: RewardTypeEnum.SINGLE,
                },
                {
                  label: 'Tập thể',
                  value: RewardTypeEnum.GROUP,
                },
              ]}
            />
          </BaseForm.Item>
        </BaseForm>
      }
    />
  )
}

const InputNumberWrapper = styled(InputNumber)`
  width: 100%;
`
